import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, } from 'react-router-dom';
import services from '../../services/index.js';
import { useDispatch, useSelector } from 'react-redux';
import { selectLanguage, selectSelectedCurrency } from '../../store/user.js';
import CustomModal from './modal.jsx';
import useHandleAddProduct from '../../utils/handleAddProduct.js';
import CustomButton from './button.jsx';
import zakatImg from '../../images/highlights/zakat.png';
import mobileAppImage from '../../images/highlights/matw-mobile-icon.png';
import { BasketIcon, CloseIcon, SearchIcon, TimeIcon, TriangleRightArrowIcon } from './customIcons.jsx';
import { BASKET_CACHE_KEY, IsExpired } from '../../utils/handleLocalStorage.js';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { selectNavbarMenu } from '../../store/menu.js';
import { selectProducts } from '../../store/products.js';
import { generateLinkWithLang } from '../../utils/linkGenerator.js';
// import ReactCountryFlag from 'react-country-flag';
import { useTranslation } from 'react-i18next';
import frFlag from '../../images/flags/frLangFlag.svg';
import usaFlag from '../../images/flags/usLangFlag.svg';
import usaFlagNav from '../../images/flags/usa-flag-square.jpg';
import ukFlag from '../../images/flags/gb-flag.svg';
import globeFlag from '../../images/flags/globe.svg';
import ausFlag from '../../images/flags/aus.svg';
import globeFlagBlue from '../../images/flags/globeBlue.svg';
import MegaMenu from "../MegaMenu";
import { openSheet } from '../../store/sheetToggler.js';
import { selectWidgetProducts } from '../../store/widgetCart.js';
import useCartBadge from '../../hooks/cart/useCartBadge.jsx';
import { setDailyDonationStatus } from '../../utils/setDailyDonationStatus.js';

const styles = {
    textShadow: {
        textShadow: `1px 2px 0 rgba(0, 0, 0, 0.15)`,
    }, textHovers: {}, textHover: {
        opacity: 1,
    }, textNotHover: {
        opacity: 0.5,
    },
};

const CustomNavbar = props => {
    /* ----------------------------- Start variables ---------------------------- */
    const navigate = useNavigate();
    const { isUk, isRamadanPage, scrollPosition, hideDonateNowButton = false, isRelative = false, isUSARoute = false, showUserFlag = false } = props;
    const selectedCurrencyStore = useSelector(selectSelectedCurrency);
    const menus = useSelector(state => selectNavbarMenu(state));
    const [userIP, setUserIP] = useState('');
    const [countryCode, setCountryCode] = useState('');
    const [isLoaded, setIsLoaded] = useState(false);
    const [mainMenuIsOpen, setMainMenuIsOpen] = useState(false);
    const [allProducts, setAllProducts] = useState();
    const [allMenus, setAllMenus] = useState([0, 0, 0, 0, 0, 0]);
    const [megaMenuItems, setMegaMenuItems] = useState([0, 0, 0, 0, 0, 0]);
    const [searchBoxIsOpen, setsearchBoxIsOpen] = useState(false);
    const [searchedText, setSearchedText] = useState('');
    const [searchResults, setSearchResults] = useState();
    const [hoveredMenu, setHoveredMenu] = useState({ id: -1, hovered: false });
    const [showModal, setShowModal] = useState(false);
    const [subMenuActive, setSubMenuActive] = useState(-1);
    const [addProduct] = useHandleAddProduct();
    let basketStatesFromLocalStorage = JSON.parse(localStorage.getItem(BASKET_CACHE_KEY));
    const language = useSelector(selectLanguage);
    const products = useSelector(state => selectProducts(state));
    const { i18n } = useTranslation();
    const lang = i18n.language;
    // const language = 'en';
    // const isUSDomain = window.location.hostname.includes('matwprojectusa.org');
    const [flag, setFlag] = useState(globeFlag);
    const [languages, setLanguages] = useState([
        { name: 'en', label: 'English', isSelected: !(['fr', 'ar', 'es'].includes(lang)), flag: globeFlag },
        { name: 'fr', label: 'Français', isSelected: lang === 'fr', flag: globeFlag },
        { name: 'ar', label: 'العربية', isSelected: lang === 'ar', flag: globeFlag },
        { name: 'es', label: 'Español', isSelected: lang === 'es', flag: globeFlag },
    ]);
    const [selectedLang, setSelectedLang] = useState({ name: 'en', flag: flag });
    const [mobileLangSwitcher, setMobileLangSwitcher] = useState(false);
    // console.log("currentLang=",lang)
    const dispatch = useDispatch()
    const selectedWidgetProducts = useSelector(selectWidgetProducts);
    const isCartPage = useCartBadge()
    const inputRef = useRef(null);
    const isDailyDonation = JSON.parse(localStorage.getItem('IS_DAILY_DONATION'));
    /* -------------------------------------------------------------------------- */
    /* ------------------------------ Start methods ----------------------------- */
    const handleSubMenu = index => {
        subMenuActive === index ? setSubMenuActive(-1) : setSubMenuActive(index);
    };
    const handleActiveMenuHover = id => {
        setHoveredMenu({ ...hoveredMenu, id: id, hovered: true });
    };
    const handleActiveMenuHoverOut = () => {
        setHoveredMenu({ ...hoveredMenu, id: -1, hovered: false });
    };
    const getAllProducts = async () => {
        try {
            const response = await services.searchProducts();
            let temp = response.data.filter(n => Number(n.status) === 1);
            setAllProducts(temp);
        } catch (error) {
            console.error('error========', error);
        }
    };

    const getMegaMenuSearchSection = async () => {
        try {
            let response = await services.getMegaMenuSearchSection();
            let megaMenuItems = response?.data || [];
            setMegaMenuItems(megaMenuItems);
        } catch (error) {
            console.error('error========', error);
        }
    }

    const handleSearch = value => {
        let searchResult = [];
        setSearchResults('');
        if (value.length > 2) {
            allProducts.map(product => {
                if (product.name.toLowerCase().includes(value.toLowerCase()) && !product.name.toLowerCase().includes('qurban')) {
                    searchResult.push(product);
                }
                return searchResult;
            });
            setSearchResults(searchResult);
        }
    };
    const handleSelectedProduct = code => {
        products.map(item => {
            item.sub_categories.map(inner_item => {
                inner_item.products.map(inner_item_product => {
                    if (inner_item_product.creator === code) {
                        // console.log('found', code, inner_item_product);
                        addProduct({ product: inner_item_product, currency: selectedCurrencyStore ? selectedCurrencyStore : 'AUD' })
                    }
                    return inner_item_product;
                });
                return inner_item;
            });
            return item;
        });
    };
    const handleClearSearch = () => {
        setSearchedText('');
        setSearchResults('');
    };
    const getAllMenus = () => {
        setIsLoaded(true)
        // let temp = [...menus];
        // temp[0].children[0].status = true;
        // temp[0].children[0] = Object.assign({}, temp[0].children[0], {
        //   status: true
        // });
        // temp[0] = Object.assign({}, temp[0], {
        //   status: 0
        // });
        // console.log("menus on navbar=",temp,temp[0].children[0])
        // setAllMenus(temp);
        setAllMenus(menus);
    };

    const handleChangeLanguage = (name) => {
        i18n.changeLanguage(name);
        let temp = [...languages];


        if (name.toLowerCase() === 'fr') {
            setSelectedLang({ name: 'fr', flag: globeFlag });
            temp[0].isSelected = false;
            temp[1].isSelected = true;
            temp[2].isSelected = false;
            temp[3].isSelected = false;
        } else if (name.toLowerCase() === 'ar') {
            setSelectedLang({ name: 'ar', flag: globeFlag });
            temp[0].isSelected = false;
            temp[1].isSelected = false;
            temp[2].isSelected = true;
            temp[3].isSelected = false;
        } else if (name.toLowerCase() === 'es') {
            setSelectedLang({ name: 'es', flag: globeFlag });
            temp[0].isSelected = false;
            temp[1].isSelected = false;
            temp[2].isSelected = false;
            temp[3].isSelected = true;
        } else {
            setSelectedLang({ name: 'en', flag: globeFlag });
            temp[0].isSelected = true;
            temp[1].isSelected = false;
            temp[2].isSelected = false;
            temp[3].isSelected = false;
        }

        setLanguages(temp);

        // Handle URL path changes
        const updatePath = () => {
            let _path = window.location.pathname;

            const removeLanguageCode = (url) => {
                const parts = url.split('/');
                if (['fr', 'ar', 'es'].includes(parts[1])) {
                    parts.splice(1, 1); // Remove the language code
                }
                return parts.join('/');
            };

            const generateLinkWithLang = (url, lang) => {
                const parts = url.split('/');
                parts.splice(1, 0, lang); // Insert language code at index 1
                return parts.join('/');
            };

            _path = removeLanguageCode(_path);

            // Redirect based on language
            if (name === 'en') {
                window.location.href = _path;
            } else if (['fr', 'es', 'ar'].includes(name) && lang !== name) {
                _path = generateLinkWithLang(_path, name);
                window.location.href = _path;
            }
        };

        updatePath();
    };

    /* -------------------------------------------------------------------------- */
    /* ------------------------------- Start hooks ------------------------------ */
    useEffect(() => {
        menus && Object.keys(menus).length && !isLoaded && getAllMenus();

        console.log(menus)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [menus]);
    // useEffect(() => {
    //   // console.log("lang=",lang)
    //   if (lang.toLowerCase() === 'fr') {
    //     setSelectedLang({ name: 'fr', flag: frFlag })
    //   } else {
    //     if (window.location.pathname.includes('/fr')) {
    //       setSelectedLang({ name: 'fr', flag: frFlag })
    //       // i18n.changeLanguage('fr');
    //     } else {
    //       setSelectedLang({ name: 'en', flag: usaFlag })
    //     }
    //   }
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [lang]);
    useEffect(() => {
        const _pathname = window.location.pathname;
        setDailyDonationStatus();
        if (_pathname.startsWith('/fr')) {
            if (_pathname.startsWith('/friday')) {
                setSelectedLang({ name: 'en', flag: globeFlag });
                i18n.changeLanguage('en');
            } else {
                setSelectedLang({ name: 'fr', flag: globeFlag });
                i18n.changeLanguage('fr');
            }
        } else if (_pathname.startsWith('/ar')) {
            setSelectedLang({ name: 'ar', flag: globeFlag });
            i18n.changeLanguage('ar');
        } else if (_pathname.startsWith('/es')) {
            setSelectedLang({ name: 'es', flag: globeFlag });
            i18n.changeLanguage('es');
        } else {
            setSelectedLang({ name: 'en', flag: globeFlag });
                i18n.changeLanguage('en');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window.location.pathname, userIP]);
    useEffect(() => {
        if (searchBoxIsOpen && inputRef.current) {
            inputRef.current.focus();
        }
    }, [searchBoxIsOpen]);
    useEffect(() => {
        getAllProducts();
    }, []);

    useEffect(() => {
        getMegaMenuSearchSection()
    }, [])

    useEffect(() => {
        if (!userIP) {
            fetch('https://matwproject.org/ip-api')
                .then(res => res.json())
                .then(response => {
                    setUserIP(response.query);
                    setCountryCode(response.countryCode);

                    // Set flag based on country
                    if (response.countryCode === 'US') {
                        setFlag(usaFlag);
                    } else if (response.countryCode === 'UK') {
                        setFlag(ukFlag);
                    } else if (response.countryCode === 'GB') {
                        setFlag(ukFlag);
                    } else if (response.countryCode === 'AU') {
                        setFlag(ausFlag);
                    } else {
                        setFlag(globeFlag);
                    }
                })
                .catch(error => console.log('Request failed:', error));
        }
    }, [userIP]);
    useEffect(() => {
        setLanguages(prevLanguages =>
            prevLanguages.map(lang =>
                lang.name === 'en' ? { ...lang, flag } : lang
            )
        );
    }, [flag]);
    /* -------------------------------------------------------------------------- */
    return (<nav
        className={`bg-gradient-to-r from-[#00a3da] to-[#093484] transition-all duration-300 ${isRamadanPage ? 'sticky top-0 w-full z-40' : !isRamadanPage ? 'sticky top-0 w-full z-40' : 'relative'} ${hoveredMenu.id === 0 && hoveredMenu.hovered ? '!relative-' : 'sticky'} ${isRelative ? "!relative" : ""}`}
    >
        <div className="xl:container mx-auto  lg:px-3 xl:px-0">
            <div className="relative flex h-16 lg:h-24 items-center justify-between">
                <div className="flex items-center justify-start md:justify-start sm:items-stretch w-full h-full">
                    {/* /* ------------------------------- Start logo ------------------------------- */}
                    <div
                        className="flex w-full lg:w-auto lg:flex-shrink-0 lg:hidden items-center justify-between px-0 xl:px-3">
                        <div className="flex items-center">
                            {!isUSARoute && (
                                <button
                                    type="button"
                                    className="inline-flex items-center p-2 mr-2 text-md text-white bg-[#f60362] focus:outline-none h-16"
                                    onClick={() => setMainMenuIsOpen(!mainMenuIsOpen)}
                                >
                                    <svg
                                        className={`${mainMenuIsOpen ? 'hidden' : 'block'} h-6 w-6`}
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        aria-hidden="true"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round"
                                            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                                    </svg>
                                    <svg
                                        className={`${mainMenuIsOpen ? 'block' : 'hidden'} h-6 w-6`}
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        aria-hidden="true"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            )}
                            {isUSARoute ? (
                                <div className="flex items-center md:w-auto h-16 pl-2">
                                    <img
                                        className="w-[41px] h-[40px] sm:w-[49px] sm:h-[48px]"
                                        src="https://cdn.matwproject.org/images/general/logo-transparent.png"
                                        alt="Muslim Charity MATW"
                                        title="Islamic Charity MATW"
                                    />
                                    <h5 className="hidden- lg:block text-white ml-2 text-[10px] sm:text-[14px] uppercase">MATW
                                        Project</h5>
                                </div>
                            ) : (
                                <Link to="/">
                                    <div className="flex items-center md:w-auto h-16">
                                        <img
                                            className="w-[41px] h-[40px] sm:w-[49px] sm:h-[48px]"
                                            src="https://cdn.matwproject.org/images/general/logo-transparent.png"
                                            alt="Muslim Charity MATW"
                                            title="Islamic Charity MATW"
                                        />
                                        <h5 className="hidden- lg:block text-white ml-2 text-[10px] sm:text-[14px] uppercase">MATW
                                            Project</h5>
                                    </div>
                                </Link>
                            )}
                        </div>
                        <div className="h-16 flex items-end cursor-pointer" onClick={() => setShowModal(true)}>
                            {/* <img src={youtubeImg} alt="matw" className="max-h-[64px] w-[50px] h-[46px] min-[450px]:w-[69px] min-[450px]:h-[64px]" /> */}
                        </div>
                        <div className="flex items-center h-16 pr-2-">
                            {!isUSARoute && scrollPosition > 110 && (<div
                                className={`flex flex-col px-2 items-center text-[12px] h-16 justify-center transition-all duration-200 text-white cursor-pointer border-l border-white border-opacity-10`}
                                // onClick={() => navigate('/zakat')}
                                onClick={() => navigate(generateLinkWithLang('/zakat', lang))}
                            >
                                <img src={zakatImg} alt="zakat"
                                    className="w-[30px] circle_animation-zakat rounded-full" />
                                Zakat
                            </div>)}
                            {!isUSARoute && (
                                <div
                                    className={`relative flex ${scrollPosition > 110 ? 'px-2' : 'px-3'} items-center h-16 justify-center transition-all duration-200 text-white cursor-pointer border-l border-white border-opacity-10`}
                                    onClick={() => setsearchBoxIsOpen(!searchBoxIsOpen)}
                                >
                                    {searchBoxIsOpen ? (<CloseIcon
                                        className="w-6 h-6 cursor-pointer transition-all duration-300 hover:rotate-90" />) : (
                                        <SearchIcon className="w-6 h-6 cursor-pointer" />)}
                                </div>
                            )}
                            {/* <div
                  className={`lang_switcher_mobile relative flex px-1 items-center h-16 justify-center transition-all duration-200 text-white cursor-pointer border-l border-white border-opacity-10`}>
                </div> */}
                            <div
                                className={`relative flex px-2 items-center h-16 justify-center transition-all duration-200 text-white cursor-pointer border-l border-white border-opacity-10`}
                                onClick={() => setMobileLangSwitcher(!mobileLangSwitcher)}
                            >
                                <div className="relative">
                                    <span style={styles.textShadow}
                                        className="text-white text-[14px] transition-all duration-200 uppercase cursor-pointer flex items-center">
                                        {/* {languages.filter(item => item.isSelected).map((item, index) => {
                        return <div key={`langs_mobile${index}`} className='flex items-center'>
                          {item.label}
                        </div>
                      })} */}
                                        <div className='flex items-center'>
                                            {selectedLang.name.toUpperCase()}
                                        </div>
                                    </span>
                                    {mobileLangSwitcher &&
                                        <ul className="notranslate flex flex-col absolute bg-white rounded-md p-1 shadow-md -right-3 z-[99]">
                                            {languages.map(item => {
                                                return <li key={`langs${item.name}`}
                                                    className="group/submenu transition-all relative duration-200 hover:bg-stone-100 flex items-center justify-between">
                                                    <div className="flex items-center text-[#777]">
                                                        <div
                                                            className={`py-1 cursor-pointer flex items-center transition-all duration-200 px-1 text-[15px] ${item.isSelected ? 'text-DarkerBlue' : ''} hover:text-[#00a3da]`}
                                                            onClick={() => handleChangeLanguage(item.name)}
                                                        >
                                                            {/* {console.log("label=", item.label)} */}
                                                            <span className="ml-0">{item.label}</span>
                                                        </div>
                                                    </div>
                                                </li>
                                            })}
                                        </ul>}
                                </div>
                            </div>
                            {/* /* ---------------------------------- cart ---------------------------------- */}
                            {!isDailyDonation
                                ? isCartPage ? (
                                    <div
                                        className={`relative flex items-center ${scrollPosition > 110 ? 'px-3' : 'px-4'} h-16 bg-[#0f4a99] justify-center text-white cursor-pointer border-l border-white border-opacity-20`}
                                        onClick={() => dispatch(openSheet())}>
                                        {basketStatesFromLocalStorage && basketStatesFromLocalStorage.products.length && basketStatesFromLocalStorage.products[0].product && !IsExpired(basketStatesFromLocalStorage) && (
                                            <div
                                                className="flex rounded-full bg-[#ED0B6D] w-[16px] h-[16px] absolute right-4 top-4 border border-white text-xs items-center justify-center">
                                                {/* {basketStatesFromLocalStorage.products.length > 0 && basketStatesFromLocalStorage.products.length} */}
                                            </div>)}
                                        <BasketIcon />
                                    </div>
                                ) :
                                    (
                                        <div
                                            className={`relative flex items-center ${scrollPosition > 110 ? 'px-3' : 'px-4'} h-16 bg-[#0f4a99] justify-center text-white cursor-pointer border-l border-white border-opacity-20`}
                                            onClick={() => navigate(generateLinkWithLang('/checkout', lang))}>
                                            {basketStatesFromLocalStorage && basketStatesFromLocalStorage.products.length && basketStatesFromLocalStorage.products[0].product && !IsExpired(basketStatesFromLocalStorage) && (
                                                <div
                                                    className="flex rounded-full bg-[#ED0B6D] w-[10px] h-[10px] absolute right-4 top-4 border border-white">

                                                </div>)}
                                            <BasketIcon />
                                        </div>
                                    )
                                : ''
                            }
                            {!hideDonateNowButton && props.navigation !== 'tiktok' && (<div
                                className={`relative flex items-center px-2 h-16 bg-[#f60362]- justify-center text-white cursor-pointer border-l border-white border-opacity-10`}>
                                <CustomButton
                                    link="/top-10"
                                    title={'Donate'}
                                    className="h-[38px] blob red !px-2"
                                />
                            </div>)}
                            {isUSARoute && (
                                <>
                                    <div
                                        className={`flex items-center h-16 justify-center transition-all duration-200 px-2 text-white border-r border-white border-opacity-10 cursor-pointer`}
                                        style={hoveredMenu.hovered ? (hoveredMenu.id === -4 ? styles.textHover : styles.textNotHover) : styles.textHovers}
                                        onMouseEnter={() => handleActiveMenuHover(-4)}
                                        onMouseLeave={() => handleActiveMenuHoverOut()}
                                        onClick={() => setShowModal(true)}
                                    >
                                        <img
                                            src={"https://cdn.matwproject.org/static/media/ali-banat-top.88a224fc9abb884ac15f.png"}
                                            alt="matw" className="h-16" />
                                    </div>
                                    <div id="user_flag" className={`relative flex items-center px-2 h-16 bg-[#f60362]- justify-center text-white border-white border-opacity-10`}>
                                        {showUserFlag
                                            ? <div className='w-8 flex justify-center'>
                                                {countryCode && <img src={`https://flagcdn.com/w40/${countryCode.toLowerCase()}.png`} alt="User Flag" className="w-full w-6- h-4-" />}
                                            </div>
                                            : <img src={usaFlagNav} alt="USA" className='w-6' />
                                        }
                                    </div>

                                </>
                            )}
                        </div>
                    </div>
                    {/* /* -------------------------------------------------------------------------- */}
                    {/* -------------------------- Start Menu on mobile ------------------------- */}
                    <div className="flex lg:hidden h-full">
                        <ul className={`flex flex-col absolute bg-[#00a3da] left-0 w-full top-16 transition-all duration-200 ease-linear z-[99] overflow-hidden ${mainMenuIsOpen ? 'open navbar' : 'navbar'}`}>
                            <li className={`relative w-full py-2 px-4 border-b border-[#81c3ed]`}>
                                <div
                                    className="bg-white rounded w-full basis-full- md:basis-3/4- flex px-2 items-center py-1">
                                    <p className="text-stone-400 font-light border-r border-stone-300 h-8 w-max whitespace-nowrap pr-2 mr-2 flex items-center">
                                        Search MATW:
                                    </p>
                                    <input
                                        ref={inputRef} // Attach the ref here
                                        type="text"
                                        name='searching'
                                        className="rounded focus:border-0 focus:outline-none w-full h-10"
                                        placeholder="Search for..."
                                        value={searchedText}
                                        onChange={e => {
                                            setSearchedText(e.target.value);
                                            handleSearch(e.target.value);
                                        }}
                                    />
                                    <div className="flex items-center justify-center w-5 h-5">
                                        {searchedText !== '' && (<svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                            className="w-5 h-5 cursor-pointer transition-all duration-300 hover:text-[#f60362] hover:rotate-90"
                                            onClick={() => handleClearSearch()}
                                        >
                                            <path
                                                d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                                        </svg>)}
                                    </div>
                                </div>
                                <div className="flex w-full flex-col max-h-[200px] overflow-y-scroll">
                                    {searchResults && searchResults.map((item, index) => {
                                        return (<div
                                            key={`searchResult${index}`}
                                            className="bg-white cursor-pointer py-2 w-full border-b border-stone-200 px-2 transition-all duration-300 hover:pl-4 block"
                                            // to={`/checkout?id=${Base64.encode(JSON.stringify({ product: item.creator, currency: selectedCurrencyStore ? selectedCurrencyStore : 'AUD' }))}`}
                                            onClick={() => handleSelectedProduct(item.creator)}
                                        >
                                            {item.name}
                                        </div>);
                                    })}
                                </div>
                            </li>
                            {allMenus.map((item, index) => {
                                if (item) {
                                    if (item.children.length) {
                                        return (item.status === 1 || item.status === true) && (
                                            <React.Fragment key={`top-${index}`}>
                                                {item.children.map((level2Item, level2Index) => {
                                                    return (level2Item.status === 1 || level2Item.status === true) && (
                                                        <li key={`nav_${level2Index}`}
                                                            className={`relative w-full py-2 px-4 border-b border-[#81c3ed] ${language === 'ar' ? 'font-[AlmariMedium]' : ''}`}>
                                                            {level2Item.children.length ? (<>
                                                                <div
                                                                    className="group relative flex w-full text-white items-center"
                                                                    onClick={() => handleSubMenu(level2Index)}>
                                                                    <TriangleRightArrowIcon
                                                                        className={`w-3 h-3 transition-all duration-300 ${subMenuActive === level2Index ? 'transform rotate-90' : ''}`}
                                                                    />
                                                                    <span
                                                                        className="text-white px-3 text-[15px] font-medium cursor-pointer flex">{level2Item.title}</span>
                                                                </div>
                                                                <ul
                                                                    className={`flex-col transition-all duration-200 ease-linear bg-[#65bff7] rounded-md px-4 min-w-[270px] z-[99] overflow-hidden ${subMenuActive === level2Index ? 'h-auto my-2 py-4' : 'h-0'}`}
                                                                >
                                                                    {level2Item.children.map((innerItem, innerIndex) => {
                                                                        return innerItem.children.length && (innerItem.status === 1 || innerItem.status === true) ? (
                                                                            <div key={innerIndex}
                                                                                className="flex items-center gap-1">
                                                                                {innerItem.children.map((item, index) => (
                                                                                    <React.Fragment
                                                                                        key={index}>
                                                                                        <li className="text-white cursor-pointer py-1 block transition-all duration-200 px-3 text-[15px] hover:text-[#00a3da]">
                                                                                            <Link
                                                                                                to={generateLinkWithLang(item.url, lang)}
                                                                                                rel={item.no_follow ? 'nofollow' : ''}
                                                                                                aria-current="page"
                                                                                                title={item.title}>
                                                                                                {item.title}
                                                                                            </Link>
                                                                                        </li>
                                                                                        {index !== innerItem.children.length - 1 &&
                                                                                            <span
                                                                                                className="text-white">|</span>}
                                                                                    </React.Fragment>))}
                                                                            </div>) : (innerItem.status === 1 || innerItem.status === true) && (
                                                                                <li key={`innernav_${innerIndex}`}
                                                                                    className="transition-all duration-200 hover:bg-stone-100">
                                                                                    <Link
                                                                                        className="text-white cursor-pointer py-1 block transition-all duration-200 px-3 text-[15px] hover:text-[#00a3da]"
                                                                                        aria-current="page"
                                                                                        to={generateLinkWithLang(innerItem.url, lang)}
                                                                                        rel={innerItem.no_follow ? 'nofollow' : ''}
                                                                                        title={innerItem.title}
                                                                                    >
                                                                                        {innerItem.title}
                                                                                    </Link>
                                                                                </li>);
                                                                    })}
                                                                </ul>
                                                            </>) : (<>
                                                                <Link
                                                                    to={generateLinkWithLang(level2Item.url, lang)}
                                                                    rel={level2Item.no_follow ? 'nofollow' : ''}
                                                                    className="text-white px-3 text-[15px] font-medium"
                                                                    aria-current="page"
                                                                    onClick={() => {
                                                                        setMainMenuIsOpen(false);
                                                                        handleSubMenu(-1);
                                                                    }}
                                                                >
                                                                    {level2Item.title}
                                                                </Link>
                                                                {level2Item.secondHref && (<>
                                                                    <span className="text-white">|</span>
                                                                    <Link
                                                                        to={level2Item.secondHref}
                                                                        rel={level2Item.no_follow ? 'nofollow' : ''}
                                                                        className="text-white px-3 text-[15px] font-medium"
                                                                        aria-current="page"
                                                                        onClick={() => {
                                                                            setMainMenuIsOpen(false);
                                                                            handleSubMenu(-1);
                                                                        }}
                                                                    >
                                                                        {level2Item.secondName}
                                                                    </Link>
                                                                </>)}
                                                            </>)}
                                                        </li>);
                                                })}
                                            </React.Fragment>);
                                    } else {
                                        return (item.status === 1 || item.status === true) && (<li key={`nav__${index}`}
                                            className="relative w-full py-2 px-4 border-b border-[#81c3ed]">
                                            <Link
                                                to={generateLinkWithLang(item.url, lang)}
                                                rel={item.no_follow ? 'nofollow' : ''}
                                                className="text-white px-3 text-[15px] font-medium"
                                                aria-current="page"
                                                onClick={() => {
                                                    setMainMenuIsOpen(false);
                                                    handleSubMenu(-1);
                                                }}
                                            >
                                                {item.title}
                                            </Link>
                                            {item.secondHref && (<>
                                                <span className="text-white">|</span>
                                                <Link
                                                    to={item.secondHref}
                                                    rel={item.no_follow ? 'nofollow' : ''}
                                                    className="text-white px-3 text-[15px] font-medium"
                                                    aria-current="page"
                                                    onClick={() => {
                                                        setMainMenuIsOpen(false);
                                                        handleSubMenu(-1);
                                                    }}
                                                >
                                                    {item.secondName}
                                                </Link>
                                            </>)}
                                        </li>);
                                    }
                                } else {
                                    return <li key={`nav__${index}`}
                                        className="relative w-full py-2 px-4 border-b border-[#81c3ed]">
                                        <Link
                                            to={'#'}
                                            className="text-white px-3 text-[15px] font-medium"
                                            aria-current="page"
                                            onClick={() => {
                                            }}
                                        >
                                            'title'
                                        </Link>
                                    </li>
                                }
                            })}
                            <li className="transition-all duration-200 flex flex-col justify-center items-center hover:bg-stone-100-">
                                {isUk ? (<>
                                    <a
                                        href="tel:+44 2080895843"
                                        target="_self"
                                        className="text-white cursor-pointer py-1 block transition-all duration-200 px-3 text-xl hover:text-[#00a3da]-"
                                        rel="noopener noreferrer"
                                    >
                                        0208 089 5843
                                    </a>
                                    <span
                                        className="text-white flex items-center px-3 transition-all duration-300">
                                        <TimeIcon className="w-4 h-4 mr-1" />
                                        10am-8pm
                                    </span>
                                </>) : (<>
                                    <a
                                        href={`tel:${window.location.hostname === "matwprojectusa.org" ? '+1 7035403446' : '+61 297589037'}`}
                                        target="_self"
                                        className="text-white cursor-pointer py-1 block transition-all duration-200 px-3 text-xl hover:text-[#00a3da]-"
                                        rel="noopener noreferrer"
                                    >
                                        {window.location.hostname === "matwprojectusa.org" ? '+1 (703) 540-3446' : '+61 2 9758 9037'}
                                    </a>
                                    <span
                                        className="text-white items-center flex px-3 transition-all duration-300">
                                        <TimeIcon className="w-4 h-4 mr-1" />
                                        9am-10pm
                                    </span>
                                </>)}
                            </li>
                        </ul>
                    </div>
                    {/* /* -------------------------------------------------------------------------- */}

                    {/* /* -------------------------- Start Menu on desktop -------------------------- */}
                    <div className="hidden !w-full lg:flex items-center justify-between md:w-auto">
                        {isUSARoute ? (
                            <div className="flex items-center md:w-auto h-24">
                                <img
                                    className="w-[66px] h-[64px]"
                                    src="https://cdn.matwproject.org/images/general/logo-transparent.png"
                                    alt="Muslim Charity MATW"
                                    title="Islamic Charity MATW"
                                />
                                <h5 className="text-white ml-2 text-[10px] sm:text-[14px] uppercase">MATW
                                    Project</h5>
                            </div>
                        ) : (
                            <Link className="" to={generateLinkWithLang('/', lang)}>
                                <div className="flex items-center md:w-auto h-24">
                                    <img
                                        className="w-[66px] h-[64px]"
                                        src="https://cdn.matwproject.org/images/general/logo-transparent.png"
                                        alt="Muslim Charity MATW"
                                        title="Islamic Charity MATW"
                                    />
                                    <h5 className="text-white ml-2 text-[10px] sm:text-[14px] uppercase">MATW
                                        Project</h5>
                                </div>
                            </Link>
                        )}
                        <ul className="flex flex-col md:flex-row h-full- h-24" id="desktop_menu">
                            <li
                                style={hoveredMenu.hovered ? (hoveredMenu.id === -3 ? styles.textHover : styles.textNotHover) : styles.textHovers}
                                className={`lang_switcher_desktop relative flex p-2 items-center h-24 w-auto justify-center transition-all duration-200 text-white border-r border-white border-opacity-10 ${products ? 'cursor-pointer' : 'cursor-not-allowed'}`}
                                onMouseEnter={() => handleActiveMenuHover(-3)}
                                onMouseLeave={() => handleActiveMenuHoverOut()}
                            >
                                <div className="group relative">
                                    <span style={styles.textShadow}
                                        className="text-white text-[14px] transition-all duration-200 uppercase cursor-pointer flex items-center">
                                        {/* {console.log("langs=", languages)} */}
                                        {/* {languages.filter(item => item.isSelected).map((item, index) => {
                        return <div key={`langs${index}`} className='flex items-center'>
                          <ReactCountryFlag
                            countryCode={item.flag}
                            svg
                            cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
                            cdnSuffix="svg"
                            title={item.flag}
                          />
                          <span className="ml-1.5">{item.label}</span>
                        </div>
                      })} */}
                                        {/* {console.log(selectedLang.name, selectedLang.flag)} */}
                                        <div className='flex items-center'>
                                            {/* <ReactCountryFlag
                          countryCode={selectedLang.flag}
                          svg
                          cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
                          cdnSuffix="svg"
                          title={selectedLang.flag}
                        /> */}
                                            <img src={selectedLang.flag} alt={selectedLang.name} className='w-[14px]' />
                                            <span className="ml-1.5">{selectedLang.name.toUpperCase()}</span>
                                        </div>
                                    </span>
                                    <ul className="hidden w-[100px] notranslate group-hover:flex flex-col absolute bg-white rounded-md p-4 shadow-md -right-3 z-[99]">
                                        {languages.map(item => {
                                            return <li key={`langs${item.name}`}
                                                className="group/submenu transition-all relative duration-200 hover:bg-stone-100 w-[80px] flex items-center justify-between">
                                                <div className="flex items-center text-[#777]">
                                                    <div
                                                        className={`py-1 cursor-pointer flex items-center transition-all duration-200 text-[15px] ${item.isSelected ? 'text-DarkerBlue' : ''} hover:text-[#00a3da]`}
                                                        onClick={() => handleChangeLanguage(item.name)}
                                                    >
                                                        {/* <ReactCountryFlag
                                countryCode={item.flag}
                                svg
                                cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
                                cdnSuffix="svg"
                                title={item.flag}
                              /> */}
                                                        <img src={globeFlagBlue} alt={item.name} className='w-[14px]' />
                                                        {/* {console.log("label=", item.label)} */}
                                                        <span className="ml-1">{item.label}</span>
                                                    </div>
                                                </div>
                                            </li>
                                        })}
                                    </ul>
                                </div>
                            </li>
                            {!isUSARoute && allMenus.map((item, index) => {
                                if (item) {
                                    return (item.status === 1 || item.status === true) && (<li
                                        key={`menus${index}`}
                                        style={hoveredMenu.hovered ? (hoveredMenu.id === index ? styles.textHover : styles.textNotHover) : styles.textHovers}
                                        className={`relative flex items-center justify-center h-full transition-all duration-200 md:px-1- lg:px-2- xl:px-3- 2xl:px-7- border-r border-white border-opacity-10 ${index === 0 && 'border-l'} ${item.class} px-1 md:px-3 h-24`}
                                        onMouseEnter={() => handleActiveMenuHover(index)}
                                        onMouseLeave={() => handleActiveMenuHoverOut()}
                                    >
                                        {item.children.length ? (<div className="group relative">
                                            <span
                                                style={styles.textShadow}
                                                className="text-white text-[14px] transition-all duration-200 uppercase cursor-pointer flex items-center"
                                            >
                                                {item.title}
                                                <ChevronDownIcon
                                                    className={`w-4 h-4 transition-all duration-300 cursor-pointer ml-1 stroke-[4px] max-h-[400px]- overflow-visible-`} />
                                            </span>
                                            <div className={`${hoveredMenu.id === 0 && hoveredMenu.hovered ? 'w-[560px] h-[600px] overflow-y-auto absolute' : ''} scrollable-element`}>
                                                <ul className="hidden group-hover:flex flex-col absolute bg-white rounded-md p-4 shadow-md min-w-[270px] z-[99]">
                                                    <div className="max-h-[400px]- overflow-y-auto-">
                                                        {item.children.map((subMenuItem, subMenuIndex) => {
                                                            return (subMenuItem.status === 1 || subMenuItem.status === true) && (
                                                                <li
                                                                    key={`submenus${subMenuIndex}`}
                                                                    className="group/submenu transition-all relative duration-200 hover:bg-stone-100 flex items-center justify-between"
                                                                >
                                                                    {subMenuItem.children.length ? (<div
                                                                        className="flex items-center text-[#777]">
                                                                        {subMenuItem.url !== '#' ? <Link
                                                                            to={generateLinkWithLang(subMenuItem.url, lang)}
                                                                            rel={subMenuItem.no_follow ? 'nofollow' : ''}
                                                                            className="text-[#777] py-1 cursor-pointer block transition-all duration-200 px-3 text-[15px] hover:text-[#00a3da]"
                                                                            aria-current="page"
                                                                        >
                                                                            {subMenuItem.title}
                                                                        </Link> : <span
                                                                            className="text-[#777] py-1 cursor-pointer block transition-all duration-200 px-3 text-[15px] hover:text-[#00a3da]"
                                                                        >
                                                                            {subMenuItem.title}
                                                                        </span>}
                                                                        {subMenuItem.secondHref && (<>
                                                                            <span>|</span>
                                                                            <Link
                                                                                to={subMenuItem.secondHref}
                                                                                rel={subMenuItem.no_follow ? 'nofollow' : ''}
                                                                                className="py-1 cursor-pointer block transition-all duration-200 pl-2 pr-2 text-[15px] hover:text-[#00a3da]"
                                                                                aria-current="page"
                                                                            >
                                                                                {subMenuItem.secondName}
                                                                            </Link>
                                                                        </>)}
                                                                    </div>) : (<div
                                                                        className="flex items-center text-[#777]">
                                                                        <Link
                                                                            to={generateLinkWithLang(subMenuItem.url, lang)}
                                                                            rel={subMenuItem.no_follow ? 'nofollow' : ''}
                                                                            className="py-1 cursor-pointer block transition-all duration-200 pl-3 pr-2 text-[15px] hover:text-[#00a3da]"
                                                                            aria-current="page"
                                                                        >
                                                                            {subMenuItem.title}
                                                                        </Link>
                                                                        {subMenuItem.secondHref && (<>
                                                                            <span>|</span>
                                                                            <Link
                                                                                to={subMenuItem.secondHref}
                                                                                rel={subMenuItem.no_follow ? 'nofollow' : ''}
                                                                                className="py-1 cursor-pointer block transition-all duration-200 pl-2 pr-2 text-[15px] hover:text-[#00a3da]"
                                                                                aria-current="page"
                                                                            >
                                                                                {subMenuItem.secondName}
                                                                            </Link>
                                                                        </>)}
                                                                    </div>)}
                                                                    {subMenuItem.children.length ? (<>
                                                                        <ChevronDownIcon
                                                                            className={`w-4 h-4 transition-all duration-300 cursor-pointer ml-1 stroke-[2px] transform -rotate-90 left-full top-0 z-[100]`}
                                                                        />
                                                                        <ul
                                                                            className={`absolute self-start left-full hidden group-hover/submenu:flex flex-col transition-all duration-200 ease-linear bg-white rounded-md px-4 min-w-[270px] z-[99] overflow-hidden h-auto py-4 shadow-xl`}
                                                                        >
                                                                            {subMenuItem.children.map((levelThreeItem, levelThreeIndex) => {
                                                                                return (levelThreeItem.status === 1 || levelThreeItem.status === true) && levelThreeItem.children.length ? (
                                                                                    <div
                                                                                        key={`levelThreeIndex${levelThreeIndex}`}
                                                                                        className="flex items-center gap-1">
                                                                                        {levelThreeItem.children.map((item, index) => (
                                                                                            <React.Fragment
                                                                                                key={index}>
                                                                                                <li
                                                                                                    className="text-[#777] cursor-pointer py-1 block transition-all duration-200 px-3 text-[15px] hover:text-[#00a3da]"
                                                                                                    key={index}
                                                                                                >
                                                                                                    <Link
                                                                                                        to={generateLinkWithLang(item.url, lang)}
                                                                                                        rel={item.no_follow ? 'nofollow' : ''}
                                                                                                        aria-current="page"
                                                                                                        title={item.title}>
                                                                                                        {item.title}
                                                                                                    </Link>
                                                                                                </li>
                                                                                                {index !== levelThreeItem.children.length - 1 &&
                                                                                                    <span
                                                                                                        className="text-[#777] text-md">|</span>}
                                                                                            </React.Fragment>))}
                                                                                    </div>) : (levelThreeItem.status === 1 || levelThreeItem.status === true) && (
                                                                                        <li key={`submenuIndex${levelThreeIndex}`}
                                                                                            className="transition-all duration-200 hover:bg-stone-100">
                                                                                            <Link
                                                                                                className="text-[#777] cursor-pointer py-1 block transition-all duration-200 px-3 text-[15px] hover:text-[#00a3da]"
                                                                                                aria-current="page"
                                                                                                to={generateLinkWithLang(levelThreeItem.url, lang)}
                                                                                                rel={levelThreeItem.no_follow ? 'nofollow' : ''}
                                                                                                title={levelThreeItem.title}
                                                                                            >
                                                                                                {levelThreeItem.title}
                                                                                            </Link>
                                                                                        </li>);
                                                                            })}
                                                                        </ul>
                                                                    </>) : ('')}
                                                                </li>);
                                                        })}
                                                    </div>
                                                </ul>
                                            </div>
                                        </div>) : (<Link
                                            to={generateLinkWithLang(item.url, lang)}
                                            rel={item.no_follow ? 'nofollow' : ''}
                                            style={styles.textShadow}
                                            title={item.title}
                                            className="text-white flex items-center h-24 transition-all duration-200 text-[14px] uppercase"
                                            aria-current="page"
                                        >
                                            {item.title}
                                        </Link>)}
                                    </li>);
                                } else {
                                    return <li key={`nav__${index}`}
                                        className="relative min-w-[95px] flex items-center justify-center transition-all duration-200 md:px-1- lg:px-2- xl:px-3- 2xl:px-7- border-r border-white border-opacity-10 border-l undefined px-1 md:px-3 h-24">
                                        <Link
                                            to={'#'}
                                            className="text-white px-3 text-[15px] font-medium"
                                            aria-current="page"
                                            onClick={() => {
                                            }}
                                        >
                                        </Link>
                                    </li>
                                }
                            })}
                            {!isUSARoute && (
                                <li
                                    style={hoveredMenu.hovered ? (hoveredMenu.id === -2 ? styles.textHover : styles.textNotHover) : styles.textHovers}
                                    className={`relative flex items-center h-24 w-[81px] lg:w-[40px] xl:w-[60px] 2xl:w-[71px] justify-center transition-all duration-200 text-white border-r border-white border-opacity-10 ${products ? 'cursor-pointer' : 'cursor-not-allowed'}`}
                                    onMouseEnter={() => handleActiveMenuHover(-2)}
                                    onMouseLeave={() => handleActiveMenuHoverOut()}
                                    onClick={() => {
                                        products && setsearchBoxIsOpen(!searchBoxIsOpen)
                                    }}
                                >
                                    {searchBoxIsOpen ? (<CloseIcon
                                        className="w-6 h-6 cursor-pointer transition-all duration-300 hover:rotate-90" />) : (
                                        <SearchIcon className="w-6 h-6 cursor-pointer" />)}
                                </li>
                            )}
                            {/* /* ---------------------------------- cart ---------------------------------- */}
                            {!isDailyDonation
                                ? isCartPage ? (
                                    <li
                                        style={hoveredMenu.hovered ? (hoveredMenu.id === -4 ? styles.textHover : styles.textNotHover) : styles.textHovers}
                                        className={`relative flex items-center h-24 w-[81px] lg:w-[40px] xl:w-[60px] 2xl:w-[71px] justify-center transition-all duration-200 pr-1- text-white border-r border-white border-opacity-10 cursor-pointer`}
                                        onMouseEnter={() => handleActiveMenuHover(-4)}
                                        onMouseLeave={() => handleActiveMenuHoverOut()}
                                        onClick={() => dispatch(openSheet())}
                                    >
                                        {basketStatesFromLocalStorage && basketStatesFromLocalStorage.products.length && basketStatesFromLocalStorage.products[0].product && (
                                            <div
                                                className="flex rounded-full bg-[#ED0B6D] w-[10px] h-[10px] absolute right-2 xl:right-5 top-9 border border-white items-center justify-center text-[9px]">
                                                {/* {basketStatesFromLocalStorage.products.length > 0 && basketStatesFromLocalStorage.products.length} */}
                                            </div>)}
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M5.84332 13.611C5.76564 13.6813 5.71117 13.7736 5.68714 13.8756C5.66312 13.9775 5.67068 14.0844 5.70881 14.182C5.74695 14.2796 5.81386 14.3632 5.90066 14.4219C5.98747 14.4806 6.09009 14.5114 6.19485 14.5104H18.3135C18.4437 14.5104 18.5686 14.5622 18.6607 14.6542C18.7528 14.7463 18.8045 14.8712 18.8045 15.0014C18.8045 15.1316 18.7528 15.2565 18.6607 15.3486C18.5686 15.4406 18.4437 15.4923 18.3135 15.4923H6.19485C5.88967 15.4933 5.59145 15.401 5.34014 15.2278C5.08883 15.0547 4.8964 14.8089 4.78856 14.5234C4.68073 14.2379 4.66263 13.9263 4.73671 13.6302C4.8108 13.3342 4.97353 13.0678 5.20312 12.8667L6.79183 11.5196C6.44379 11.2203 6.18492 10.831 6.04363 10.3943L3.49068 2.45656C3.45554 2.34701 3.39455 2.24753 3.31285 2.16652C3.23116 2.08551 3.13117 2.02535 3.02133 1.99114L0.315189 1.13492C0.198434 1.09015 0.103164 1.00253 0.0488086 0.889921C-0.00554731 0.777311 -0.0148794 0.648206 0.0227027 0.528946C0.0602848 0.409685 0.141942 0.309259 0.251039 0.248158C0.360136 0.187057 0.488436 0.169879 0.60976 0.200141L3.3159 1.05439C3.53617 1.12391 3.74005 1.23738 3.91523 1.38792C4.09041 1.53846 4.23324 1.72296 4.3351 1.93027H4.3901H17.4887C17.8734 1.93034 18.253 2.01878 18.5981 2.18876C18.9432 2.35875 19.2447 2.60572 19.4792 2.91067C19.7138 3.21561 19.8751 3.57036 19.9509 3.94754C20.0266 4.32472 20.0147 4.71426 19.916 5.0861L18.7122 9.55574C18.5778 10.0501 18.2958 10.4916 17.9038 10.8215C17.5119 11.1513 17.0286 11.3537 16.5186 11.4017L8.66335 12.1303C8.58764 12.1374 8.51159 12.1407 8.43554 12.1401C8.18858 12.1397 7.94306 12.1026 7.70698 12.0301L5.84332 13.611ZM9.37818 16.4369C9.04432 16.4377 8.71818 16.5374 8.44096 16.7235C8.16374 16.9095 7.94788 17.1736 7.82065 17.4822C7.69343 17.7909 7.66055 18.1303 7.72615 18.4577C7.79176 18.785 7.95293 19.0856 8.18928 19.3214C8.42562 19.5572 8.72657 19.7177 9.05408 19.7825C9.38158 19.8474 9.72094 19.8137 10.0293 19.6857C10.3377 19.5578 10.6012 19.3413 10.7866 19.0637C10.972 18.786 11.071 18.4597 11.071 18.1258C11.0705 17.9032 11.026 17.6828 10.9402 17.4774C10.8544 17.2719 10.729 17.0854 10.571 16.9286C10.413 16.7717 10.2257 16.6475 10.0196 16.5632C9.8136 16.4788 9.59295 16.4359 9.37032 16.4369H9.37818ZM16.3929 16.4369C16.0591 16.4377 15.7329 16.5374 15.4557 16.7235C15.1785 16.9095 14.9626 17.1736 14.8354 17.4822C14.7082 17.7909 14.6753 18.1303 14.7409 18.4577C14.8065 18.785 14.9677 19.0856 15.204 19.3214C15.4404 19.5572 15.7413 19.7177 16.0688 19.7825C16.3963 19.8474 16.7357 19.8137 17.044 19.6857C17.3524 19.5578 17.616 19.3413 17.8014 19.0637C17.9868 18.786 18.0857 18.4597 18.0857 18.1258C18.0852 17.9032 18.0408 17.6828 17.955 17.4774C17.8692 17.2719 17.7437 17.0854 17.5857 16.9286C17.4278 16.7717 17.2404 16.6475 17.0344 16.5632C16.8284 16.4788 16.6077 16.4359 16.3851 16.4369H16.3929Z"
                                                fill="#fff"
                                            />
                                        </svg>
                                    </li>
                                ) :
                                    (
                                        <li
                                            style={hoveredMenu.hovered ? (hoveredMenu.id === -4 ? styles.textHover : styles.textNotHover) : styles.textHovers}
                                            className={`relative flex items-center h-24 w-[81px] lg:w-[40px] xl:w-[60px] 2xl:w-[71px] justify-center transition-all duration-200 pr-1- text-white border-r border-white border-opacity-10 cursor-pointer`}
                                            onMouseEnter={() => handleActiveMenuHover(-4)}
                                            onMouseLeave={() => handleActiveMenuHoverOut()}
                                            onClick={() => navigate(generateLinkWithLang('/checkout', lang))}
                                        >
                                            {basketStatesFromLocalStorage && basketStatesFromLocalStorage.products.length && basketStatesFromLocalStorage.products[0].product && (
                                                <div
                                                    className="flex rounded-full bg-[#ED0B6D] w-[10px] h-[10px] absolute right-2 xl:right-5 top-9 border border-white"></div>)}
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M5.84332 13.611C5.76564 13.6813 5.71117 13.7736 5.68714 13.8756C5.66312 13.9775 5.67068 14.0844 5.70881 14.182C5.74695 14.2796 5.81386 14.3632 5.90066 14.4219C5.98747 14.4806 6.09009 14.5114 6.19485 14.5104H18.3135C18.4437 14.5104 18.5686 14.5622 18.6607 14.6542C18.7528 14.7463 18.8045 14.8712 18.8045 15.0014C18.8045 15.1316 18.7528 15.2565 18.6607 15.3486C18.5686 15.4406 18.4437 15.4923 18.3135 15.4923H6.19485C5.88967 15.4933 5.59145 15.401 5.34014 15.2278C5.08883 15.0547 4.8964 14.8089 4.78856 14.5234C4.68073 14.2379 4.66263 13.9263 4.73671 13.6302C4.8108 13.3342 4.97353 13.0678 5.20312 12.8667L6.79183 11.5196C6.44379 11.2203 6.18492 10.831 6.04363 10.3943L3.49068 2.45656C3.45554 2.34701 3.39455 2.24753 3.31285 2.16652C3.23116 2.08551 3.13117 2.02535 3.02133 1.99114L0.315189 1.13492C0.198434 1.09015 0.103164 1.00253 0.0488086 0.889921C-0.00554731 0.777311 -0.0148794 0.648206 0.0227027 0.528946C0.0602848 0.409685 0.141942 0.309259 0.251039 0.248158C0.360136 0.187057 0.488436 0.169879 0.60976 0.200141L3.3159 1.05439C3.53617 1.12391 3.74005 1.23738 3.91523 1.38792C4.09041 1.53846 4.23324 1.72296 4.3351 1.93027H4.3901H17.4887C17.8734 1.93034 18.253 2.01878 18.5981 2.18876C18.9432 2.35875 19.2447 2.60572 19.4792 2.91067C19.7138 3.21561 19.8751 3.57036 19.9509 3.94754C20.0266 4.32472 20.0147 4.71426 19.916 5.0861L18.7122 9.55574C18.5778 10.0501 18.2958 10.4916 17.9038 10.8215C17.5119 11.1513 17.0286 11.3537 16.5186 11.4017L8.66335 12.1303C8.58764 12.1374 8.51159 12.1407 8.43554 12.1401C8.18858 12.1397 7.94306 12.1026 7.70698 12.0301L5.84332 13.611ZM9.37818 16.4369C9.04432 16.4377 8.71818 16.5374 8.44096 16.7235C8.16374 16.9095 7.94788 17.1736 7.82065 17.4822C7.69343 17.7909 7.66055 18.1303 7.72615 18.4577C7.79176 18.785 7.95293 19.0856 8.18928 19.3214C8.42562 19.5572 8.72657 19.7177 9.05408 19.7825C9.38158 19.8474 9.72094 19.8137 10.0293 19.6857C10.3377 19.5578 10.6012 19.3413 10.7866 19.0637C10.972 18.786 11.071 18.4597 11.071 18.1258C11.0705 17.9032 11.026 17.6828 10.9402 17.4774C10.8544 17.2719 10.729 17.0854 10.571 16.9286C10.413 16.7717 10.2257 16.6475 10.0196 16.5632C9.8136 16.4788 9.59295 16.4359 9.37032 16.4369H9.37818ZM16.3929 16.4369C16.0591 16.4377 15.7329 16.5374 15.4557 16.7235C15.1785 16.9095 14.9626 17.1736 14.8354 17.4822C14.7082 17.7909 14.6753 18.1303 14.7409 18.4577C14.8065 18.785 14.9677 19.0856 15.204 19.3214C15.4404 19.5572 15.7413 19.7177 16.0688 19.7825C16.3963 19.8474 16.7357 19.8137 17.044 19.6857C17.3524 19.5578 17.616 19.3413 17.8014 19.0637C17.9868 18.786 18.0857 18.4597 18.0857 18.1258C18.0852 17.9032 18.0408 17.6828 17.955 17.4774C17.8692 17.2719 17.7437 17.0854 17.5857 16.9286C17.4278 16.7717 17.2404 16.6475 17.0344 16.5632C16.8284 16.4788 16.6077 16.4359 16.3851 16.4369H16.3929Z"
                                                    fill="#fff"
                                                />
                                            </svg>
                                        </li>
                                    )
                                : ''
                            }
                            {/* /* -------------------------------- Ali Banat ------------------------------- */}
                            {/* <li
                  style={hoveredMenu.hovered ? (hoveredMenu.id === -4 ? styles.textHover : styles.textNotHover) : styles.textHovers}
                  className={`hidden xl:flex items-center h-24 justify-center transition-all duration-200 px-2 text-white border-r border-white border-opacity-10 cursor-pointer`}
                >
                  <div className="gtranslate_wrapper" onClick={handleClick}></div>
                </li> */}
                            <li
                                style={hoveredMenu.hovered ? (hoveredMenu.id === -4 ? styles.textHover : styles.textNotHover) : styles.textHovers}
                                className={`hidden xl:flex items-center h-24 justify-center transition-all duration-200 px-2 text-white border-r border-white border-opacity-10 cursor-pointer`}
                                onMouseEnter={() => handleActiveMenuHover(-4)}
                                onMouseLeave={() => handleActiveMenuHoverOut()}
                                onClick={() => setShowModal(true)}
                            >
                                <img
                                    src={"https://cdn.matwproject.org/static/media/ali-banat-top.88a224fc9abb884ac15f.png"}
                                    alt="matw" className="w-[103px] h-[96px] hidden md:block" />
                            </li>
                            <li className='flex items-center justify-center'>
                                {isUSARoute && (
                                    <div id="user_flag" className={`relative flex items-center px-2 h-16 bg-[#f60362]- justify-center text-white border-white border-opacity-10`}>
                                        {showUserFlag
                                            ? <div className='w-12 flex justify-center'>
                                                {countryCode && <img src={`https://flagcdn.com/w40/${countryCode.toLowerCase()}.png`} alt="User Flag" className="w-full w-6- h-4-" />}
                                            </div>
                                            : <img src={usaFlagNav} alt="USA" className='w-12' />
                                        }
                                    </div>
                                )}
                            </li>
                        </ul>
                        {!hideDonateNowButton && props.navigation !== 'tiktok' && (<div className="flex items-center h-24">
                            <div
                                className="flex flex-col items-center h-20 justify-end group transition-all duration-300 hover:pb-5 md:p-1 md:pl-2">
                                <CustomButton
                                    link="/top-10"
                                    title={'Donate'}
                                    className="w-[83px] h-[38px] blob red !px-2"
                                />
                                {isUk ? (<>
                                    <a href="tel:+44 2080895843" target="_self" rel="noopener noreferrer"
                                        className="text-white">
                                        0208 089 5843
                                    </a>
                                    <span
                                        className="text-white flex items-center text-sm absolute opacity-0 top-[90px] -right-[10px]- right-0 px-3 transition-all duration-300 group-hover:top-[70px] group-hover:opacity-100">
                                        <TimeIcon className="w-4 h-4 mr-1" />
                                        10am-8pm
                                    </span>
                                </>) : (<>
                                    {window.location.hostname !== 'matwprojectfr.org' ? (<>
                                        <a href={`tel:${window.location.hostname === "matwprojectusa.org" ? '+1 7035403446' : '+61 297589037'}`}
                                            target="_self" rel="noopener noreferrer"
                                            className="text-white">
                                            {window.location.hostname === "matwprojectusa.org" ? '+1 (703) 540-3446' : '+61 2 9758 9037'}
                                        </a>
                                        <span
                                            className="text-white flex items-center text-sm absolute opacity-0 top-[90px] -right-[10px]- right-0 px-3 transition-all duration-300 group-hover:top-[70px] group-hover:opacity-100">
                                            <TimeIcon className="w-4 h-4 mr-1" />
                                            9am-10pm
                                        </span>
                                    </>) : ('')}
                                </>)}
                            </div>
                        </div>)}
                    </div>
                    {/* /* -------------------------------------------------------------------------- */}
                </div>
            </div>
            {/* /* ---------------------------- Start Search box ----------------------------  */}
            {searchBoxIsOpen && (<div className="w-full flex flex-wrap justify-center items-center bg-[#00a3da] min-h-32 z-50 absolute px:6 md:px-0 left-0 py-5">
                <div className="basis-full md:basis-3/4 flex flex-col justify-center px-2 lg:px-0">
                    {/* <Link to={'/crisis-and-emergencies/palestine'} className='hidden'>Donate to Palestine</Link> */}
                    <div className="flex w-full">
                        <div className="bg-white rounded w-full flex px-2 items-center py-1">
                            <p className="text-stone-400 font-light border-r border-stone-300 h-8 w-max whitespace-nowrap pr-2 mr-2 flex items-center">
                                Search MATW:
                            </p>
                            <input
                                ref={inputRef} // Attach the ref here
                                type="text"
                                name='searchingMobile'
                                className="rounded focus:border-0 focus:outline-none w-full h-10"
                                placeholder="Search for..."
                                value={searchedText}
                                onChange={e => {
                                    setSearchedText(e.target.value);
                                    handleSearch(e.target.value);
                                }}
                            />
                            <div className="flex items-center justify-center w-5 h-5" onClick={() => {
                                if (searchedText !== '') {
                                    setSearchedText('');
                                    handleSearch('');
                                }
                            }}>
                                {searchedText !== '' && (<CloseIcon
                                    className="w-5 h-5 cursor-pointer transition-all duration-300 hover:text-[#f60362] hover:rotate-90" />)}
                            </div>
                        </div>
                    </div>

                    {
                        /**
                         * -- PREVIOUS IMPLEMENTATION
                         *                           !searchResults && <div className="text-white flex flex-col mt-2">
                         *                           <span className='mb-1'>Commonly searched:</span>
                         *                           <Link to={'/zakat-calculator'}>Zakat Calculator</Link>
                         *                           <Link to={'/crisis-and-emergencies/palestine'}>Donate to Palestine</Link>
                         *                         </div>
                         * TODO: Developer@Obaid - Feat(UI) - add mega menu to navbar under search
                         * Feature: Working on MegaMenu
                         * -- Get the mega menu items from the provided URL, separate from the allMenus URL
                         * */
                    }
                    {!searchResults && (<div className="text-white flex flex-col mt-2">
                        {megaMenuItems?.data?.length ? (<div>
                            <span className='mb-1'>Commonly searched:</span>
                            <MegaMenu
                                /* megaMenuData={{
                                       data: allMenus
                                           .filter(menu => menu.section === "main")
                                           .map(menu => ({
                                             ...menu,
                                             // transform if needed
                                           }))
                                     }}*/
                                megaMenuData={megaMenuItems}
                                TriangleRightArrowIcon={TriangleRightArrowIcon}
                            />
                        </div>) : (<div></div>)}
                    </div>)}

                    <div className="flex w-full flex-col max-h-[200px] overflow-y-scroll">
                        {searchResults && searchResults.map((item, index) => {
                            return (<div
                                key={`searchResult${index}`}
                                className="bg-white cursor-pointer py-2 w-full border-b border-stone-200 px-2 transition-all duration-300 hover:pl-4 block"
                                onClick={() => handleSelectedProduct(item.creator)}
                            >
                                {item.name}
                            </div>);
                        })}
                    </div>
                </div>
            </div>)}
            {/* /* --------------------------------------------------------------------------  */}
        </div>
        {showModal && (<CustomModal show={showModal} onClose={() => setShowModal(false)} className="md:w-2/3" title="">
            <iframe
                className="video md:min-h-[400px]"
                width={'100%'}
                height={'100%'}
                title="Gifted with Cancer - Ali Banat"
                sandbox="allow-same-origin allow-forms allow-popups allow-scripts allow-presentation"
                src={`https://youtube.com/embed/dzL6BLPAFBo?autoplay=0?feature=oembed`}
            ></iframe>
        </CustomModal>)}
        {/* FloatingButton */}
        {/* {showRegularImg && <Link to="/qurban" className="fixed top-1/2 -translate-y-[20%] md:-translate-y-1/2 right-0 z-[30] md:z-[50]">
        <img src={imgFloatingButtonDesk} alt="img" className="hidden md:block" />
        <img src={imgFloatingButtonMob} alt="img" className="md:hidden" />
      </Link>} */}
    </nav>);
};

export default CustomNavbar;